module.exports = __webpack_public_path__ + "static/media/maze.64e30f2d.png";